import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiUsers, FiArrowRight } = FiIcons;

const WhatsAppPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 8000); // 8 seconds delay

    return () => clearTimeout(timer);
  }, []);

  const handleJoin = () => {
    window.open('https://chat.whatsapp.com/E8bqQ0e70W8HQyRAPtKde8', '_blank');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setIsVisible(false)}
          >
            {/* Popup Card */}
            <motion.div
              initial={{ scale: 0.8, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.8, opacity: 0, y: 20 }}
              className="bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setIsVisible(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <SafeIcon icon={FiX} className="text-xl" />
              </button>

              <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-8 text-white text-center">
                <motion.div
                  animate={{ 
                    scale: [1, 1.1, 1],
                    rotate: [0, 5, -5, 0]
                  }}
                  transition={{ 
                    duration: 4, 
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                  className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-md"
                >
                  <SafeIcon icon={FiUsers} className="text-3xl" />
                </motion.div>
                <h3 className="text-2xl font-bold mb-2">Wait! Don't Miss Out</h3>
                <p className="text-green-50 opacity-90">
                  Join 500+ premium entrepreneurs in our private WhatsApp community for exclusive updates.
                </p>
              </div>

              <div className="p-8 text-center">
                <p className="text-gray-600 mb-6">
                  Get instant access to pre-workshop materials and network with high-ticket closers.
                </p>
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleJoin}
                  className="w-full bg-emerald-600 text-white py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-emerald-700 transition-all flex items-center justify-center gap-2"
                >
                  Join Community Now <SafeIcon icon={FiArrowRight} />
                </motion.button>
                <button
                  onClick={() => setIsVisible(false)}
                  className="mt-4 text-sm text-gray-400 hover:text-gray-600 font-medium"
                >
                  Maybe later, take me to dashboard
                </button>
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppPopup;